export const dotenv = {
  API_BASE_URL: 'https://sc-api-dev.naicotech.com',
  WS_URL: 'https://sc-gateway-dev.naicotech.com',
  FRONTEND_URL: 'https://sc-web-dev-v2.naicotech.com',
  GOOGLE_CLIENT_ID:
    '1090586343889-o1ce0990pqqsp8159mp1f5cnh423mul9.apps.googleusercontent.com',
  VITE_FIREBASE_API_KEY: 'AIzaSyAnkKBdDZ_32d5-yErtInJFVAPmAW8oxOg',
  VITE_FIREBASE_AUTH_DOMAIN: 'smart-contractor-471108.firebaseapp.com',
  VITE_FIREBASE_PROJECT_ID: 'smart-contractor-471108',
  VITE_FIREBASE_STORAGE_BUCKET: 'smart-contractor-471108.firebasestorage.app',
  VITE_FIREBASE_MESSAGING_SENDER_ID: '1090586343889',
  VITE_FIREBASE_APP_ID: '1:1090586343889:web:3a5ed360e7581d470708f0',
  VITE_FIREBASE_VAPID_KEY:
    'BKpmXoKzlEn8ExKSwPhXUcx-ehPrnHJ-aggy_DVB6vWlRF4eSwwZZo2OVAHb8wfzeeUjRkV7JPathNzYp0Pg-0o',
  VITE_GOOGLE_MAPS_API_KEY: 'AIzaSyCr8HANmdsiFOBuwo28LDhnyu3CHYJbCAM'
};
